

















import Vue from 'vue'

export default Vue.extend({
  props: {
    track: { type: Object, required: true },
  },
  data() {
    return {
      starred: this.track.starred,
    }
  },
  methods: {
    toggleStarred() {
      this.starred = !this.starred
      if (this.starred) {
        return this.$api.unstar('track', this.track.id)
      }
      return this.$api.star('track', this.track.id)
    },
    setNextInQueue() {
      return this.$store.dispatch('player/setNextInQueue', this.track)
    },
    addToQueue() {
      return this.$store.dispatch('player/addToQueue', this.track)
    },
  }
})
